'use strict';

function ButtonSpinnerController() {
  var vm = this;
  vm.$onInit = $onInit;

  function $onInit() {
    vm.active = vm.active === true || false;
    vm.disabled = vm.disabled === true || false;
    vm.buttonClass = vm.buttonClass || 'btn btn-new primary';
    vm.stateActiveIcon = vm.stateActiveIcon || 'fa fa-refresh fa-spin fa-fw';
    vm.stateActiveText = vm.stateActiveText || vm.stateNormalText || '';
    vm.type = vm.type || 'submit';
  }
}

module.exports = ButtonSpinnerController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/button-spinner/button-spinner.controller.js
 ** module id = 44
 ** module chunks = 0
 **/